module.exports = __webpack_public_path__ + "media/images/tutorial_header_pc3-05-1ec16be55292d7fc126bb979758aadf9.png";